import React from "react";

const pill = { ok: "bg-emerald-50 text-emerald-700", missing: "bg-rose-50 text-rose-700", unconfirmed: "bg-amber-50 text-amber-700" };

const Sec = ({ title, children, id }) => (
  <section className="space-y-1" data-testid={id}><h3 className="text-sm font-semibold">{title}</h3>{children}</section>
);

function Fields({ d }) {
  return (
    <div className="text-xs">{d.fields.map((f) => (
      <div key={f.field} className="border-t py-1 grid grid-cols-1 sm:grid-cols-[140px_1fr_1fr_90px] gap-x-2" data-testid={`pilot-field-${f.field}`}>
        <span className="font-semibold">{f.field}</span>
        <span className="break-words min-w-0">{String(f.value ?? "—")}{f.correction && <span className="block text-indigo-700">Proposed: {f.correction.after}</span>}{d.imported && f.catalogue_value !== undefined && <span className="block text-slate-500">Catalogue: {String(f.catalogue_value ?? "—")}</span>}</span>
        <span className="text-slate-500 break-words min-w-0">{f.source}</span>
        <span><span className={`px-1.5 py-0.5 rounded ${pill[f.status]}`} data-testid={`pilot-field-${f.field}-status`}>{f.status}</span></span>
      </div>))}</div>
  );
}

export function PilotReadiness({ d }) {
  const le = d.link_evidence, av = d.availability_source;
  return (
    <div className="space-y-4" data-testid="pilot-readiness">
      <Sec title="Actions requiring your approval" id="pilot-approvals">
        <ul className="text-xs space-y-0.5">{d.approvals.map((a, i) => (
          <li key={a.action} data-testid={`pilot-approval-${i}`}><span className={a.done ? "text-emerald-700" : "text-amber-700"}>{a.done ? "done" : "pending"}</span> · <span className="uppercase text-[10px] text-slate-500">{a.stage}</span> · {a.action}</li>))}</ul>
      </Sec>
      <Sec title={`Link verification: ${le.verdict}${le.saved ? " (approved)" : " (not saved)"}`} id="pilot-link-evidence">
        <ul className="text-xs">{le.evidence.map((e) => <li key={e.evidence}><span className={e.ok ? "text-emerald-700" : "text-rose-700"}>{e.ok ? "pass" : "fail"}</span> · {e.evidence} · <span className="text-slate-500">{e.detail}</span></li>)}</ul>
        <p className="text-xs text-slate-500">{le.note}</p>
      </Sec>
      <Sec title="Product information, sources and proposed corrections" id="pilot-fields"><Fields d={d} /></Sec>
      <Sec title="Brand evidence (unconfirmed until you check the physical label)" id="pilot-brand-evidence">
        <ul className="text-xs list-disc pl-4">{d.brand_evidence.map((b) => <li key={b.source}><b>{b.source}:</b> {b.finding}</li>)}</ul>
      </Sec>
      <Sec title="Image requirements" id="pilot-image-evidence">
        <p className="text-xs">Google: min 100×100 today, 500×500 required for January 2027; 1500×1500 recommended; no watermarks or promotional overlays. The published image will be a TedOps-hosted copy you upload.</p>
        <ul className="text-xs text-slate-600">{d.image_evidence.map((i) => <li key={i.src} className="break-all">{i.src} · {i.check?.width ? `${i.check.width}×${i.check.height} ${i.check.format || ""} (earlier read)` : i.check?.errors?.length ? `not verifiable - ${i.check.errors.join("; ")} (website bot protection)` : "not verifiable - website bot protection"}</li>)}</ul>
      </Sec>
      <Sec title="Availability source" id="pilot-availability">
        <p className="text-xs"><b>Now:</b> {av.current}{av.verified ? ` · ${av.verified.stock_status}${av.verified.stock_quantity != null ? ` (website qty ${av.verified.stock_quantity})` : ""} · checked ${new Date(av.verified.fetched_at).toLocaleString()}` : " · not checked yet"}</p>
        <p className="text-xs"><b>TedOps stock today:</b> {av.tedops_stock_now} — {av.tedops_stock_note}</p>
        <p className="text-xs"><b>Later:</b> {av.future}</p>
      </Sec>
      <Sec title="Missing information / blockers" id="pilot-missing">
        {d.missing.length ? <ul className="text-xs text-rose-700 list-disc pl-4">{d.missing.map((m) => <li key={m}>{m}</li>)}</ul> : <p className="text-xs text-emerald-700">None</p>}
      </Sec>
    </div>
  );
}
